import { umengEvent } from "../index";
import { PurchaseError } from "@/services/payment/types";

export const sendInterfaceSuccess = (name: string) => {
  umengEvent(name, {
    error_code: 200,
    error_message: "ok"
  });
};

export const sendCgInterfaceError = (name: string, error: PurchaseError) => {
  try {
    if (error.hasOwnProperty("meta")) {
      const { meta } = error;
      const { error_message, code } = meta;
      umengEvent(name, {
        error_code: code,
        error_message
      });
    } else {
      const { code, message } = error;
      umengEvent(name, {
        error_code: code,
        error_message: message
      });
    }
  } catch (e) {
    //
  }
};

export const sendInsInterfaceError = (name: string, error: any) => {
  try {
    const error_message =
      (error && (error.message || (error.meta && error.meta.error_message))) ||
      error;
    const error_code =
      (error &&
        (error.code ||
          error.status_code ||
          (error.meta && error.meta.code) ||
          error.data)) ||
      400;

    console.log("sendEventError", name, {
      error_code,
      error_message
    });
    umengEvent(name, {
      error_code,
      error_message
    });
  } catch (e) {
    console.log("ins api event error", e);
  }
};
